import { CommonKeys } from "../../../common/enums";
import { STAMM_VERTRAG_TYPE } from "../../interfaces/stammelements/StammElementVertrag";

export const FormularGroupStammStammElementVertragSchema = {
    $id: "FormularGroupStammStammElementVertragSchema",
    title: "FormularGroupStammStammElementVertrag Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_VERTRAG_TYPE },
                Property: { type: "number", nullable: true }
            }
        }
    ],
};